import { useState , useEffect } from 'react'
import styles from './styles.module.sass'

export default function Express(props){
    const {
        setToggleExpress,
        resetFilters
    } = props

    const [ attribute , setAttribute ] = useState(false)
    const [ toggle , setToggle ] = useState(false)

    const handleToggle = () => {
        setToggle(!toggle)
    }

    useEffect(()=>{
        if(resetFilters){
            setToggle(false)
            setAttribute(false)
            setToggleExpress(false)
        }
    },[resetFilters])
    
    useEffect(()=>{
        if(toggle){
            setAttribute(true)
            setToggleExpress(true)
        }else{
            setAttribute(false)
            setToggleExpress(false)
        }
    },[toggle])

    return(
        <div className={styles?.seccionFulfillment}>
            <div className={styles?.cajaFulfillment}>
                <div className={styles?.cajaTexto}>
                    <img className="express" src="./img/Express.svg" alt="express" />
                </div>
                <div className={styles?.cajaSwitch}>
                   <label htmlFor="fullfilment">
                        <input
                            className={styles?.input}
                            type="checkbox"
                            checked={attribute === true}
                            onChange={ handleToggle }
                            id="fullfilment"
                        />
                        <div className={styles?.toggle}>
                            <span className={styles?.selector} />
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
    
}